import { render } from "./AiconeLogo.vue?vue&type=template&id=f6480170&scoped=true"
import script from "./AiconeLogo.vue?vue&type=script&lang=js"
export * from "./AiconeLogo.vue?vue&type=script&lang=js"

import "./AiconeLogo.vue?vue&type=style&index=0&id=f6480170&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6480170"]])

export default __exports__